/**
 * Origin-relative endpoints.
 *
 * Both the Vite dev server and the production nginx config proxy `/api` and
 * `/ws` to the API, so there is nothing here to switch between environments.
 * The predecessor read VITE_API_URL at build time and fell back to
 * `http://localhost:8000` whenever the hostname happened to be "localhost",
 * which meant a build shipped to a box and reached over an SSH tunnel talked to
 * the operator's own laptop instead of the aircraft.
 */

export const API_PREFIX = '/api';
export const WS_PATH = '/ws';

/** Absolute WebSocket URL for the current page origin. */
export function wsUrl(path: string = WS_PATH): string {
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}${path}`;
}

/** How long a single API call may take before the client gives up on it. */
export const REQUEST_TIMEOUT_MS = 15_000;

/** Mission upload moves a lot more bytes than a command and needs its own budget. */
export const LONG_REQUEST_TIMEOUT_MS = 60_000;

export const WS_BACKOFF = {
  baseMs: 500,
  maxMs: 15_000,
  /** Fraction of the delay applied as random jitter, +/-. */
  jitter: 0.3,
} as const;

/** How many activity entries the shell keeps. Older ones fall off the end. */
export const ACTIVITY_LOG_LIMIT = 200;
